import { apiSlice } from './apiSlice';

export type ISession = {
  sessionId: string;
};

export const historyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateSessionId: builder.query<ISession, {pathId: string, source: string}>({
      query: (body) => ({
        url: 'client/history',
        method: 'POST',
        body,
      }),
      keepUnusedDataFor: 1,
    }),
    updateHistoryBySessionId: builder.mutation<void, { sessionId: string; body: { finished: boolean } }>({
      query: ({ sessionId, body }) => ({
        url: `client/history/${sessionId}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const { useGenerateSessionIdQuery, useUpdateHistoryBySessionIdMutation } = historyApi;

